<template>
  <v-dialog :value="model.active" width="348" persistent>
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left>{{ selected.id ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ selected.id ? 'Update' : 'Add' }} Section
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form v-model="model.valid">
          <v-text-field
            outlined
            dense
            clearable
            label="Name"
            :rules="[formRules.required]"
            placeholder="Enter Name..."
            v-model="selected.name">
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          :loading="updateLoading"
          elevation="0"
          @click="saveChanges"
          :disabled="!model.valid || !model.hasChanges">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { log, warn, error } from '@/utils/debugLogger';
  import { $isEqual } from '@Utils';
  import formRules from '@Share/config/form-rules';
  import { mapGetters } from 'vuex';
  import { TaskFieldType, taskFieldList } from '@Share/config/enums';
  export default {
    name: 'edit-task-field',
    data() {
      return {
        selected: {},
        selectedCemented: {},
        TaskFieldType,
        formRules,
        taskFieldList,
        selectedType: null,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
      };
    },
    computed: {
      ...mapGetters('TASK_MANAGER', {
        updateLoading: 'GET_UPDATE_LOADING',
      }),
    },
    methods: {
      open(item, selectedType) {
        this.model.active = true;
        this.selectedType = structuredClone(selectedType);
        if (item) this.selected = structuredClone(item);
        this.cementSelected();
      },
      saveChanges() {
        
        if (!this.selectedType.sections) this.selectedType.sections = [];
       

        if (this.selected.id) {
          const index = this.selectedType.sections.findIndex((elm) => elm.id == this.selected.id);
          if (index !== -1) this.selectedType.sections.splice(index, 1, this.selected);
        } else {
          this.selectedType.sections.push(this.selected);
        }
        
        this.$store.dispatch('TASK_MANAGER/UPDATE', this.selectedType).then((data) => {
          log('Task section updated', data);
          this.$emit('updateSelected', data);
          this.cementSelected();
          this.closeDialog();
        });
      },
      reset() {
        this.model.active = false;
        this.selected = {};
        this.selectedCemented = {};
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>
